import { TaskTypeStatus } from '@econtractor/types';

export const KANBAN_COLUMNS: Array<{ status: number; tone: string }> = [
    { status: TaskTypeStatus.NEW, tone: 'new' },
    { status: TaskTypeStatus.INWORK, tone: 'inwork' },
    { status: TaskTypeStatus.COMPLETED, tone: 'completed' },
    { status: TaskTypeStatus.ACCEPTED, tone: 'accepted' },
];
